import { Box, Typography } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";

export default function Loader({ isLoading }) {
  const letters = "HELVIETA".split("");
  const starCount = 80;

  // Generate random stars
  const stars = Array.from({ length: starCount }, (_, i) => ({
    id: i,
    size: Math.random() * 3 + 1,
    top: Math.random() * 100 + "%",
    left: Math.random() * 100 + "%",
    delay: Math.random() * 2,
    duration: Math.random() * 2 + 1,
  }));

  // Soft floating letter animation
  const letterVariants = {
    initial: { y: 0, scale: 1, opacity: 1 },
    animate: {
      y: [0, -6, 0], // gentle float
      scale: [1, 1.05, 1], // subtle scaling
      opacity: [1, 0.95, 1], // soft glow effect
      transition: { yoyo: Infinity, duration: 2, ease: "easeInOut" },
    },
    exit: {
      y: -30,
      opacity: 0,
      transition: { duration: 0.8, ease: "easeInOut" },
    },
  };

  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{
            opacity: 0,
            transition: { duration: 0.8, ease: "easeInOut" },
          }}
          style={{
            position: "fixed",
            inset: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#0B0B0B",
            overflow: "hidden",
            zIndex: 5000,
          }}
        >
          {/* Twinkling Stars */}
          {stars.map((star) => (
            <motion.div
              key={star.id}
              style={{
                position: "absolute",
                top: star.top,
                left: star.left,
                width: star.size,
                height: star.size,
                borderRadius: "50%",
                backgroundColor: "#FFF",
                opacity: 0.8,
              }}
              animate={{ opacity: [0.2, 1, 0.2] }}
              transition={{
                duration: star.duration,
                repeat: Infinity,
                delay: star.delay,
                ease: "easeInOut",
              }}
            />
          ))}

          {/* HELVIETA Letters */}
          <Box sx={{ display: "flex", gap: 2, position: "relative" }}>
            {letters.map((letter, index) => (
              <motion.div
                key={index}
                variants={letterVariants}
                initial="initial"
                animate="animate"
                exit="exit"
                transition={{ delay: index * 0.1 }}
                style={{ display: "inline-block", position: "relative" }}
              >
                <Typography
                  sx={{
                    fontFamily: "Playfair Display",
                    fontSize: { xs: "2rem", md: "4rem" },
                    fontWeight: 700,
                    letterSpacing: "0.1em",
                    color: "#C6A972",
                    textShadow: "0 0 20px rgba(198,169,114,0.6)",
                  }}
                >
                  {letter}
                  {/* Soft shimmer effect */}
                  <motion.div
                    style={{
                      position: "absolute",
                      inset: 0,
                      background:
                        "linear-gradient(120deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0.5) 50%, rgba(255,255,255,0.15) 100%)",
                      transform: "skewX(-20deg)",
                      opacity: 0,
                    }}
                    animate={{ opacity: [0, 0.7, 0], x: [-150, 150, 300] }}
                    transition={{
                      repeat: Infinity,
                      duration: 3 + index * 0.1,
                      ease: "easeInOut",
                    }}
                  />
                </Typography>
              </motion.div>
            ))}
          </Box>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
